<template>
<div>

  <!-- NAVBAR -->
  <nav v-if="user" class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" @click="home()">
        <img src="./assets/android-chrome-192x192.png" height="28">
      </a>
      <a
        role="button"
        class="navbar-burger burger"
        aria-label="menu"
        aria-expanded="false"
        data-target="navbarBasicExample"
        v-on:click="showNav = !showNav" v-bind:class="{ 'is-active' : showNav }" 
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div id="navbarBasicExample" class="navbar-menu" v-bind:class="{ 'is-active' : showNav }">
    <div class="navbar-start">
      <router-link class="navbar-item" to="/"><span>Home</span></router-link>
      <router-link class="navbar-item" to="/dashboard"><span>Dashboard</span></router-link>
      <router-link class="navbar-item" to="/milkschedule"><span>Milchliste</span></router-link>
    </div>

    <div class="navbar-end">
      <div class="navbar-item">
        <div class="buttons">
          <!--
          <a class="button is-primary">
            <strong>Sign up</strong>
          </a>
          <a class="button is-light">
            Log in
          </a> -->
          <a v-if="user" @click="logout" class="button is-light">
            Log out
          </a>
        </div>
      </div>
    </div>
  </div>
  </nav>
  <!-- NAVBAR END -->

<!-- ROUTER VIEW -->

  <router-view/>


  <!-- ROUTER VIEW END -->
</div>

</template>

<script>
import { Auth, Hub } from 'aws-amplify';
import AmplifyStore from './store';
import { components, AmplifyEventBus } from 'aws-amplify-vue'
import moment from 'moment';

window.LOG_LEVEL = 'VERBOSE';

export default {
  data() {
    return {
      showNav: false,
    }
  },
  computed: {
    user() { 
      return AmplifyStore.state.user
    }, 
  },
  components: {
    ...components
  }, 
  methods: {
    logout: async function() {
        await Auth.signOut();
        AmplifyEventBus.$emit('authState', 'signedOut');
    },
    home: function() {
      this.$router.push('/');
    }
  },
  async mounted() {
   // set local for moment.js globally
    let locale = window.navigator.userLanguage || window.navigator.language;
    moment.locale(locale);
  }
}
</script>



<style>
</style>
